import "./introGraphic.scss";

export const introGraphic = {
  template: require('./introGraphic.html'),
};